import {
  params,
  arrayOf as arrayType,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';

export const dataModel = {
  collection: params({ collectionId: stringType().isRequired(), storeId: stringType().isRequired() }).shape({
    descriptors: arrayType(shapeType({
      description: stringType(),
      heading: stringType(),
      descriptiveAttributes: arrayType(shapeType({
        value: stringType()
      }))
    })),
    details: shapeType({
      description: stringType(),
      descriptiveAttributes: arrayType(shapeType({
        value: stringType()
      }))
    }),
    metadata: shapeType({
      brandName: stringType()
    })
  })
};
